import { createSelector } from 'reselect';
import { AppState } from 'store/types/Store';

const getMap = (state: AppState) => state.map;

export const getCurrentViewport = createSelector(
  [getMap],
  (map) => map.currentViewport
);

export const getIsPlacingPin = createSelector(
  [getMap],
  (map) => map.isPlacingPin
);

export const getIsRecenterButtonVisible = createSelector(
  [getMap],
  (map) => map.isRecenterButtonVisible
);
